<app-list-view
  [columnDefinition]="columnDefinition"
  [contextMenuDefinition]="contextMenuDefinition"
  [itemsSource]="itemsSource"
  [preferencesKey]="'rent.representative-rows.list'"
  (rowClick)="onRowClick($event)"
></app-list-view>
